module.exports = __webpack_public_path__ + "img/rpa15.40d1e1dc.png";